import React from 'react';
import { OrganizationPlan } from '../../services/AdminOrganizations';

const STYLES: Record<OrganizationPlan, string> = {
  trial: 'bg-amber-100 text-amber-800',
  active: 'bg-emerald-100 text-emerald-800',
  paused: 'bg-slate-200 text-slate-700',
  cancelled: 'bg-red-100 text-red-800',
};

export const PLAN_LABELS: Record<OrganizationPlan, string> = {
  trial: 'Trial',
  active: 'Active',
  paused: 'Paused',
  cancelled: 'Cancelled',
};

/** An organization's plan, marked "ended" once its end date has passed. */
const PlanBadge: React.FC<{ plan: OrganizationPlan; planEndsAt: string | null }> = ({
  plan,
  planEndsAt,
}) => {
  const ended = !!planEndsAt && new Date(planEndsAt).getTime() <= Date.now();
  return (
    <span
      className={`rounded-full px-2 py-0.5 text-xs font-medium ${
        ended ? 'bg-red-100 text-red-800' : STYLES[plan] ?? STYLES.active
      }`}
    >
      {PLAN_LABELS[plan] ?? plan}
      {ended ? ' · ended' : ''}
    </span>
  );
};

export default PlanBadge;
